import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { clientsListCSV } from 'reports/DownloadableReports/clients/actions';
import ClientsListDownload from 'reports/DownloadableReports/clients/components/ClientsListDownload';

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({ clientsListCSV }, dispatch);
}

export function mapStateToProps(state) {
  const { settings, currentSalon } = state;
  const { clientList } = settings;
  const { isFetching, errorMessage } = clientList.clientList;
  const { id: salonId } = currentSalon;
  return { salonId, isFetching, errorMessage };
}

export default connect(mapStateToProps, mapDispatchToProps)(ClientsListDownload);
